import { useContext } from 'react';
import { LocaleContext } from './LocaleContext';

/**
 * A hook to retrieve locale information.
 */
export const useLocale = () => {
  const { locale } = useContext(LocaleContext);

  return locale;
};
